import { render, staticRenderFns } from "./QuickSearchLatest.vue?vue&type=template&id=557b913b"
import script from "./QuickSearchLatest.vue?vue&type=script&lang=js"
export * from "./QuickSearchLatest.vue?vue&type=script&lang=js"
import style0 from "./QuickSearchLatest.vue?vue&type=style&index=0&id=557b913b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports